import { Box, BoxProps, Grid, GridItem, Image, SimpleGrid } from "@chakra-ui/react";
import { useDeepAuth } from "components/api";
import { AFFAIR_KINDS, Bogyo } from "components/appComponents";
import { TAffairKind, useVVStore } from "components/store";
import { VizvCard, VizvCardHeader } from "components/vizvComponents";

export interface AffairCreateKindProps {
	onSelectKind: (v: TAffairKind) => void;
}

export function AffairCreateKind({ onSelectKind: pOnSelectKind }: AffairCreateKindProps) {

	const isFull = useVVStore(state => state.isFull());
	const auth = useDeepAuth();
	const onSelectKind = (v: TAffairKind) => {
		//if (auth.signedUser) {
			pOnSelectKind(v);
		/*} else {
			auth.showSignIn('Az eset jelentéséhez be kell jelentkezned!');
		}*/
	}

	return <>
		<VizvCardHeader boxShadow='vvcard'>Mit észleltél?</VizvCardHeader>
		{/*<Box display='flex' gap={8} flexDir='column'  alignItems='center' flex={1}
			{...isFull && {
				flexDir:'row',
			}}
		
		>*/}
		<SimpleGrid columns={isFull?5:1} spacing={10} justifyItems='center'>
			<VVKindCard img="/images/vizminoseg.jpg" head="Vízminőség" head2="problémát" kind='vizminoseg' onClick={() => onSelectKind('vizminoseg')} >
				<ul className='normal'>
					<li>Vízhiányt</li>
					<li>Nyomáscsökkenést</li>
					<li>Koszos (sárgás-barnás), büdös víz folyik a csapból</li>
				</ul>
			</VVKindCard>

			<VVKindCard img="/images/csotores.jpg" head="Csőtörést" kind='csotores' onClick={() => onSelectKind('csotores')} >
				<ul className='normal'>
					<li>Vezetékes vízszivárgást</li>
					<li>Útburkolat kimosódását</li>
				</ul>
			</VVKindCard>

			<VVKindCard img="/images/kozkut.jpg" head="Közkút" head2="meghibásodását" kind='kozkut' onClick={() => onSelectKind('kozkut')} >
				<ul className='normal'>
					<li>Közkút elzárását</li>
				</ul>
			</VVKindCard>

			<VVKindCard img="/images/dugulas.jpg" head="Dugulást" kind='dugulas' onClick={() => onSelectKind('dugulas')} >
				<ul className='normal'>
					<li>Szennyvíz csatorna szivárgását</li>
				</ul>
			</VVKindCard>

			<VVKindCard img="/images/eloviz.jpg" head="Élővíz" head2="szennyezését" kind='eloviz' onClick={() => onSelectKind('eloviz')} >
				<ul className='normal'>
					<li>Szennyvízzel</li>
					<li>Egyéb környezetszennyező anyaggal</li>
				</ul>
			</VVKindCard>
		</SimpleGrid>
	</>
}

export interface VVKindCardProps extends BoxProps {
	kind: TAffairKind;
	img: string;
	head: React.ReactNode;
	head2?: React.ReactNode;
}

export function VVKindCard({ img, head, head2, children, kind, ...rest }: VVKindCardProps) {
	const isFull = useVVStore(state => state.isFull());

	return 		<VizvCard
			flexDir='column' p={0} //flex='1'
			cursor='pointer'
			
			transition={`transform .2s ease-out`}
			role='group'
			fontSize='md'
			{...isFull ? { width: '200px', _hover:{ transform: 'translate(0, -10px)' } } : { width: '250px', _hover:{ transform: 'translate(10px, 0px)' } }}
			{...rest}

		>
			<Box
				position='relative'
				w='100%'
				h={isFull ? 'calc(50vw / 5)' : 'auto'}
				borderTopRadius="6px" overflow='hidden'
			>
				<Image
					objectFit='cover'
					w='100%' h='100%'
					src={img}
					alt={kind}
				/>
				<Box position='absolute' left={0} right={0} top={0} bottom={0} backdropFilter='grayscale(1)'
					_groupHover={{ backdropFilter: 'none' }}
				/>
			</Box>
			<Box p={2} bg={AFFAIR_KINDS[kind].color} display='flex' flexDir='row'
				position='relative' left='-.4em' top='-2em' gap={2} fontSize='xl' alignItems='center'
				boxShadow='vvtitle'
			>
				<Bogyo kind={kind} px={2} />
				<Box lineHeight='.8em'>
					<Box fontSize='larger'>{head}</Box>
					{head2 && <Box fontSize='small'>{head2}</Box>}
				</Box>
			</Box>
			<Box p={2} mt='-2em' pb={4} minHeight='150px'>
				{children}
			</Box>
		</VizvCard>


}
